import React from 'react';
import PropTypes from 'prop-types';
import { ShareLinkIcon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    marginRight: '0.375rem',
  },
});

function SocialShareCopyLink({
  handleOpenCopyModal,
  linkTitle,
  color = grey600,
}) {
  return (
    <ShareLinkIcon
      onClick={handleOpenCopyModal}
      className={`${css(styles.iconLink)}`}
      style={{ color }}
      title={linkTitle}
      role="link"
      tabIndex="0"
      data-testid="social-share-copy-link"
      size="lg"
    />
  );
}

SocialShareCopyLink.propTypes = {
  url: PropTypes.string,
  handleOpenCopyModal: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareCopyLink;
